<template>
    <div class="row blog-content">
        <div class="content col-md-10 offset-md-1">
            <div class="post-content-container text-normal" v-for="article in articles_newer"
                :key="article.id">
                <h4 class="px-0 font-bold col-lg-8 col-md-10 mb-2">
                    <span class="d-inline-block">
                        {{ article.title.rendered }}
                    </span>
                </h4>
                <div class="post-section" v-html="article.content.rendered"></div>
            </div>
            <div class="post-content-container text-normal" v-for="(post, index) in posts"
                :key="index">
                <h4 class="px-0 font-bold col-lg-8 col-md-10 mb-2">
                    <router-link v-if="post.link" :to="`/blog/${post.slug}`">
                        {{ post.title }}
                    </router-link>
                    <span v-if="!post.link" class="d-inline-block">
                        {{ post.title }}
                    </span>
                </h4>
                <Section :section="section" :articleTitle="post.title" :slug="post.slug"
                v-for="(section, index) in post.sections" :key="index" />
            </div>
            <div class="post-content-container text-normal" v-for="article in articles_older"
                :key="article.id">
                <h4 class="px-0 font-bold col-lg-8 col-md-10 mb-2">
                    <span class="d-inline-block">
                        {{ article.title.rendered }}
                    </span>
                </h4>
                <div class="post-section" v-html="article.content.rendered"></div>
            </div>
        </div>
    </div>
</template>

<script>
// import main1 from '../../assets/blog/IMG_0828.png'
import photo1 from '../../assets/blog/IMG_0894.png'
import photo2 from '../../assets/blog/IMG_0914.png'
import photo3 from '../../assets/blog/IMG_9674.png'
import photo4 from '../../assets/blog/IMG_9674-1.png'
import photo5 from '../../assets/blog/IMG_9674-2.png'
import photo6 from '../../assets/blog/IMG_9674-3.png'
import photo7 from '../../assets/blog/IMG_9674-4.png'
import photo8 from '../../assets/blog/IMG_9674-5.png'
import photo9 from '../../assets/blog/IMG_9674-6.png'
import photo10 from '../../assets/blog/IMG_9674-7.png'
import photo11 from '../../assets/blog/IMG_9674-8.png'
import photo12 from '../../assets/blog/IMG_9874.png'
import photo13 from '../../assets/blog/IMG_9874-1.png'
import photo14 from '../../assets/blog/IMG_9874-2.png'
// import photo15 from '../../assets/blog/IMG_9896.png'
import Section from './Section'

export default {
    name: "About",
    components: {
        Section,
    },
    computed: {
        articles_newer() {
            return this.$store.state.articles.filter(article => 
                Date.parse(article.date) > Date.parse(this.newDateLimit)
            ) 
        },
        articles_older() {
            return this.$store.state.articles.filter(article => 
                Date.parse(article.date) < Date.parse(this.newDateLimit)
            ) 
        }
    },
    data() {
        return {
            newDateLimit: '2020-08-22',
            posts: [
                {
                    id: 1,
                    link: false,
                    title: 'AMVCA AWARD WINNER BAGS AMBASSADORIAL DEAL WITH REVOLUTIONPLUS PROPERTY',
                    slug: "amvca-award-winner-bags-ambassadorial-deal-with-revolutionplus-property",
                    sections: [
                        {
                            type: 'video',
                            data: 'https://www.youtube.com/watch?v=htuFiHWtMQk'
                        },
                        {
                            type: 'text',
                            data: `
                                <span class="font-bold d-block">Toyin Abraham Bags Ambassadorial Deal With Revolution Plus Properties</span>
                                Award- winning Nollywood actress, filmmaker, director and producer, Olutoyin Aimakhu popularly known as Toyin Abraham has signed an ambassadorial deal with the mega and biggest real estate company in Nigeria, Revolution Plus Properties at a glamorous event held in Lagos. The event which took place in the office of the organisation, saw the influential actress who has bagged so many awards and has won the hearts of so many Nigerians both far and near with her resilience and hardwork in the industry, selected out of many penciled down for the deal. According to the CEO, Revolution Plus Properties, MR Chris Bamidele Onalaja, he explained that Mrs Abraham was singled out because of her personality and what she represents in the society. He also said she would be helping his organization energize and grow her social footprints and community with her positivity and also to establish an authentic connection with her clients and prospective ones. "In the mood of double celebration we are also showcasing another amazing promo tagged Ileya Bounty Promo. It is a time to celebrate with our Muslim clients and prospect. We are offering a super amazing promo with exciting gifts as well with No interest involved. "At revolution plus property we are here to make our clients feel safe and enjoy the benefits of procuring lands from us with no harassments and who best represents the ideology and push than Toyin Abraham," he stated. Reacting, Mrs Toyin Abraham who couldn't hide her joy thanked Revolution Plus Properties for finding her worthy of this feat, promising that the partnership would be the beginning of better things to come for both parties. " I'm really excited to start showcasing Revolution Plus Properties to the world. The company has been doing great things and also helping Nigerians with different humanitarian gestures.
                            `
                        },
                        {
                            type: 'photo',
                            data: [
                                photo1,
                                photo2,
                            ]
                        },
                        {
                            type: 'text',
                            data: '"I think why I accepted this deal is because they represent who I am and what I want to achieve and hence, we are doing this signing today which by God\'s grace will be the Beginning of better things to come," she stated. REVOLUTION PLUS is a company who is known for signing up notable personalty in the society and has once signed Adekunle gold, Rachel Oniga among others. Toyin joins other ambassadors like Odunlade Adekola, Omoni Oboli and testimony jaga who are presently also brand ambassadors of revolution plus property'
                        }
                    ]
                },
                {
                    id: 2,
                    link: false,
                    title: 'REVOLUTIONPLUS RESPONDS TO THE SOCIETY WITH COVID-19 PALLIATIVE',
                    slug: "revolutionplus-responds-to-the-society-with-covid-19-palliative",
                    sections: [
                        {
                            type: 'video',
                            data: 'https://www.youtube.com/watch?v=xUfElsPCQAI'
                        },
                        {
                            type: 'photo',
                            addedClass: true,
                            data: [
                                photo12,
                                photo13,
                                photo14,
                            ]
                        },
                    ]
                },
                {
                    id: 3,
                    link: false,
                    title: 'REVOLUTIONPLUS BOSS CELEBRATES BIRTHDAY',
                    slug: 'revolutionplus-boss-celebrates-birthday',
                    sections: [
                        {
                            type: 'photo',
                            data: [
                                photo3,
                                photo4,
                                photo5,
                                photo6,
                                photo7,
                                photo8,
                                photo9,
                                photo10,
                                photo11,
                            ]
                        }
                    ]
                }       
            ]
        }
    }
}
</script>

<style scoped>
.post-section >>> p {
    margin-bottom: 5px;
}
.post-section >>> p:empty,
.post-section >>> p:-moz-only-whitespace {
    display: none;
}
</style>